import { ElementType, ForwardedRef, forwardRef } from "react";
import {
  Button as MuiButton,
  ButtonProps as MUIButtonProps,
} from "@mui/material";

export type TButtonProps<C extends ElementType = "button"> = MUIButtonProps<
  C,
  { component?: C }
>;

const Button = forwardRef(
  <C extends ElementType>(
    props: TButtonProps<C>, //https://mui.com/material-ui/guides/composition/#with-typescript
    ref: ForwardedRef<HTMLButtonElement>,
  ) => {
    const dataInsightsId =
      props["aria-label"] ?? props["data-testid"] ?? props["data-qaid"];

    return <MuiButton ref={ref} data-insights-id={dataInsightsId} {...props} />;
  },
);

export default Button;
